import { createContext } from 'use-context-selector';
import { defaultState } from './defaultState';
import { FundTransferState } from './types';

const FundTransferContext = createContext<Partial<FundTransferState>>(defaultState);

export { FundTransferContext };
